<template>
	<section class="section">
		<div class="container-fluid">
			<card ref="card" title="" icon="">
				<form-field label="出勤前報告メール" sub="必須" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded horizontal-center">
							<span>出勤時刻の</span>
							<input class="input" :class="{'is-danger': hasError('beforeStartMinutes')}" type="text" v-model="beforeStartMinutes">
							<span>分前に送信</span>
						</p>
						<p slot="help" class="help is-danger" v-show="hasError('beforeStartMinutes')">{{ errors.beforeStartMinutes }}</p>
					</div>
				</form-field>

				<form-field label="報告なしアラートメール" sub="必須" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded horizontal-center">
							<span>出勤時刻の</span>
							<input class="input" :class="{'is-danger': hasError('beforeStartAlertMinutes')}" type="text" v-model="beforeStartAlertMinutes">
							<span>分前までに出勤前報告がなければ送信</span>
						</p>
						<p slot="help" class="help is-danger" v-show="hasError('beforeStartAlertMinutes')">{{ errors.beforeStartAlertMinutes }}</p>
					</div>
				</form-field>

				<form-field :has-wrap="false">
					<div class="edit-buttons">
						<b-button type="is-light" @click="onBackButtonClick">戻る</b-button>
						<b-button type="is-success" :loading="isLoading" @click="onRegisterButtonClick">登録</b-button>
					</div>
				</form-field>
			</card>
		</div>
	</section>
</template>

<style lang="scss" scoped>
.field {
	margin-bottom: 15px;
}

.control {
	input {
		width: 100px;
		margin: 0 10px;
	}
}
</style>

<script>
import Card from '@/components/Card'
import FormField from '@/components/FormField'
import CheckboxGroup from '@/components/CheckboxGroup'

export default {
	name: "setting-edit",
	components: {
		Card,
		FormField,
		CheckboxGroup,
	},
	data() {
		return {
			isLoading: false,
			beforeStartMinutes: '',
			beforeStartAlertMinutes: '',
			errors: {
				beforeStartMinutes: '',
				beforeStartAlertMinutes: '',
			}
		}
	},
	computed: {
	},
	mounted() {
		this.$store.commit('basic', {
			key: 'titleBarTitleStack',
			value: ['システム設定']
		})
		this.getData();
	},
	methods: {
		hasError: function(key) {
			return this.errors[key] !== '';
		},
		getData: async function() {
			let loading = this.$loading.open();
			let ep = 'settings/screen';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.beforeStartMinutes = res.data.before_start_minutes;
				this.beforeStartAlertMinutes = res.data.before_start_alert_minutes;
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loading.close();
			}
		},
		onRegisterButtonClick: async function() {
			for (let key in this.errors) {
				this.errors[key] = '';
			}

			this.isLoading = true;
			let data = {
				"before_start_minutes": this.beforeStartMinutes,
				"before_start_alert_minutes": this.beforeStartAlertMinutes,
			};
			this.$utils.log(data);

			let ep = 'settings';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$utils.toastSuccess('設定を更新しました');
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
				if (error.response.status === 400) {
					let details = error.response.data.details;
					for (let key in details) {
						this.errors[this.$utils.toCamelCase(key)] = details[key];
					}
				}
			} finally {
				this.isLoading = false;
			}
		},
		onBackButtonClick: function() {
			this.$router.go(-1);
		},
	}
}
</script>
